const Ticket = {

    // PAGE HEADER
    "ticket": "Ticket",

    // FIELDS
    "premise": "Premise",
    "zone": "Zone",
    "level": "Level",
    "unit": "Unit",
    "location_details": "Location Details",

    "complaint_category": "Complaint Category",
    "complaint_type": "Complaint Type",
    "priority": "Priority",
    "complaint_details": "Complaint Details",

    "subject": "Subject / Title",
    "description": "Description",
    "attachments": "Attachments",
    "issue_information": "Issue Information",

    "incident_date": "Incident Date",
    "incident_time": "Incident Time",
    "incident_details": "Incident Details",

    "status": "Status",
    "search": "Search",

    // DETAILS
    "assigned_to": "Assigned to",
    "assigned_by": "Assigned by",
    "assigned_at": "Assigned at",
    "created_at": "Created at",
    "created_by": "Created by",
    "updated_at": "Updated at",
    "no_description": "No description provided.",
    "no_attachments": "No attachments found",
    "status_images": "Files",
    "update_status_title": "Update Ticket Status",
    "update_status_text": "Choose the new status for this ticket.",
    "error_status_required": "Please Select a Status",
    "status_updated": "Ticket Status Updated Successfully",

    // ASSIGN
    "assign_ticket": "Assign Ticket",
    "assign_ticket_subtitle": "Pick a premise user to take ownership of this ticket.",
    "assign_to_user": "Assign To",
    "currently_assigned_to": "Currently assigned to",
    "no_assignment_yet": "Not assigned yet",
    "ticket_assigned_success": "Ticket Assigned Successfully",
    "error_assign_user": "Please Select a User",

    // HISTORY
    "ticket_history": "Ticket History",
    "no_history": "No history available",
    "status_changed_by": "Status changed by",
    "system": "System",
    "remark": "Remark",

    // TABLE HEADERS
    "table_ticket_id": "TICKET ID",
    "table_subject": "SUBJECT",
    "table_issue": "ISSUE",
    "table_category": "CATEGORY",
    "table_complaint_type": "TYPE",
    "table_priority": "PRIORITY",
    "table_society": "SOCIETY",
    "table_raised_by": "RAISED BY",
    "table_premise_unit": "PREMISE / UNIT",
    "table_status": "STATUS",
    "table_date": "DATE",

    "warn_select_premise": "Please Select a Premise First",

    // ERRORS
    "error_premise": "Select Premise",
    "error_category": "Select Complaint Category",
    "error_complaint_type": "Select Complaint Type",
    "error_priority": "Select Priority",
    "error_subject": "Enter Subject",
    "error_description": "Enter Description",
    "error_incident_date": "Select Incident Date",
}

export default Ticket;